import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { serialize } from "../../utils/url";
import { ICategoryList } from "../types";

export interface ICategoryListQueryParameters extends IPaginateable, IOrderable<"title" | "createdAt" | "updatedAt"> {
    filters?: {
        title?: string;
    };
}

export type ICategoryListQueryResult = ICategoryList;

const mapFilters = (filters: ICategoryListQueryParameters["filters"]) => {
    const { title } = filters ?? {};
    return {
        ...(title && { title }),
    };
};

export const categoryListQuery: IApiQueryFunction<ICategoryListQueryParameters> = ({ filters, pagination, order }) => {
    return {
        method: "GET",
        url: `/categories${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useCategoryListQuery = createApiQueryHook<ICategoryListQueryParameters, ICategoryListQueryResult>(
    categoryListQuery,
);
